import React, { Component } from 'react'

import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,  MDBBreadcrumb, MDBBreadcrumbItem } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBJumbotron, MDBBox } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead,  } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
//import Login from './Login';
import Axios from 'axios'
import { URL } from '../../api';
import logo from '../img/logokpru.png'
import FadeIn from 'react-fade-in';
import p1 from '../img/1656587759_2-illustration_png.png'
import p2 from '../img/1656587759_4-illustration_png.png'
import p3 from '../img/1656587761_12-illustration_png.png'
import Iframe from 'react-iframe'
import { api } from '../../api';

import { HorizontalBar } from 'react-chartjs-2';


import Swal from 'sweetalert2'
import {
  MDBTypography,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText
} from 'mdbreact';

var xlsx = require("xlsx");


export default class Masterreportpay extends Component {


  constructor(props) {
    super(props);
    this.state = {
      value: '',
      Psaaword: '',
      modal: false,
      collapse: false,
      isWideEnough: false,
      datastuKamphaengphet:[],
      team: '2565',

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onClick2 = this.onClick2.bind(this);
    this.readUploadFile = this.readUploadFile.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);


  }

  handleSubmit() {

    // alert('A name was submitted: ' + this.state.value);
    //https://research.kpru.ac.th/research_new/Administrator_ResearchPublish/getpublic


    //   const datafrm = new FormData(); 
    //   datafrm.append("studentname", this.state.datastuKamphaengphet[index].studentname);
    //   datafrm.append("fieldstudy", this.state.datastuKamphaengphet[index].fieldstudy);
    //   datafrm.append("namework", this.state.datastuKamphaengphet[index].namework);
    //   datafrm.append("publication", this.state.datastuKamphaengphet[index].publication);
    //   datafrm.append("tci", this.state.datastuKamphaengphet[index].tci);
    //   datafrm.append("levelstudent", this.state.datastuKamphaengphet[index].levelstudent);

     const form = this.state.datastuKamphaengphet;
      Axios.post("https://git.kpru.ac.th/FrontEnd_Salary/index/updatehipay",{
        check: form
      })

          .then(res => {
                if (res.status === 200) {
                 
                          Swal.fire({
                                title: 'นำเข้าข้อมูลสำเร็จ',
                                icon: 'success',
                              // showCancelButton: true,
                                confirmButtonText: 'ตกลง',
                              // cancelButtonText: 'No, keep it'
                              }).then((result) => {
                              
                              })
                      
                }
          })   
  

        


  }


  componentDidMount() {

    // fetch('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json', {
    //     method: 'GET',
    //     body: JSON.stringify(),
    //     headers: {
           
    //     }

    //   })
    //     .then(res => res.json())
    //     .then((res) => {
    //         this.setState({ datastuKamphaengphet: res })
    //     })
    //     .catch(err => {
    //       console.log('request failed', err);
    //     })


    //         Axios.get('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json',{   
    //         })
    //         .then((res) => {
    //        console.log(res.data)
          
    //        this.setState({ datastuKamphaengphet: res })
    //    })

  }

 onClick2() {
      console.log('dd')
          Axios.get('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json')
         .then((res) => {
        //  console.log(res.data)
        this.setState({ datastuKamphaengphet: res })
    })

  }


  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }


  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChange(event) { this.setState({ value: event.target.value }); }
  handleChange2(event) { this.setState({ Psaaword: event.target.value }); }


  update = () => {
    this.setState({
      name: "",
      lname: ""
    })
  }

  readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = xlsx.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = xlsx.utils.sheet_to_json(worksheet);
         //   console.log(json);
            this.setState({ datastuKamphaengphet: json })

        };
        reader.readAsArrayBuffer(e.target.files[0]);
    }
}


  render() {
    const dUrl = "https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json";

  // console.log(dUrl);
   console.log(this.state.datastuKamphaengphet)
 //console.log('dd')

    return (

      <MDBContainer fluid>
       
        <MDBRow >
          <MDBCol md="12">
            <div>
              {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
              {/* <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/> */}
              <FadeIn>
              <MDBJumbotron className="p-4" fluid >
                 
                <MDBTypography blockquote bqColor='primary' className='h-0'>
                  <MDBIcon icon="user-injured" />   นำเข้าข้อมูลเงินเดือน
                </MDBTypography>
                {/* <MDBTypography note noteColor='primary' noteTitle='ด้านนักศึกษา '> </MDBTypography> */}
                   <MDBBreadcrumb>
                        <MDBBreadcrumbItem>Home</MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>สำหรับ Admin</MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>นำเข้าข้อมูลบัณฑิต</MDBBreadcrumbItem>
                    </MDBBreadcrumb>
             
                            <br/>
                           

                            <form>
    <label htmlFor="upload">Upload File</label><br/>
    <input
        type="file"
        name="upload"
        id="upload"
        onChange={this.readUploadFile}
    />
</form>
<br/>


{this.state.datastuKamphaengphet.length !== 0 ?<>
<p>ตัวอย่างข้อมูล {this.state.datastuKamphaengphet.length} รายการ</p>
  <MDBTable small style={{ border: "1px" }} border width="100%">
                            <MDBTableHead  >
                                <tr  >
                                    <th>ลำดับ</th>
                                    <th>ชื่อนิสิตนักศึกษา</th>
                                    <th>สาขาวิชา</th>
                                    <th>ชื่อผลงาน</th>
                                    <th>การตีพิมพ์เผยแพร่</th>
                                    <th>TCI ฐาน</th>
                                    <th>ระดับ</th>
                                    <th>ระดับ</th>
                                    <th>ระดับ</th>
                                    <th>ระดับ</th>
                                   
                                </tr>
                            </MDBTableHead>


                            <MDBTableBody>
                                {this.state.datastuKamphaengphet.map((data,index) => {
                                    return <tr>
                                        <td>{index+1} </td>
                                        <td>{data.payslip_year}</td>
                                        <td>{data.payslip_month}</td>
                                        <td>{data.payslip_citizent}</td>
                                        <td>{data.customers_type}</td>
                                        <td>{data.payslip_revenue}</td>
                                        <td>{data.payslip_expenditure}</td>
                                        <td>{data.payslip_total}</td>
                                        <td>{data.payslip_status_out}</td>
                                        <td>{data.idbudget}</td>
                                      
                                      
                                    </tr>
                                })}
                            </MDBTableBody>
                        </MDBTable>
<div  className='text-center'>
     <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
</div>
                     
</>:<>

</>}
                          
                            {/* <Iframe url="https://datastudio.google.com/embed/reporting/c100fb1c-4c88-41ea-b941-b9c2e83a3935/page/Cds4C"
                                 width="100%"
                                 height="600px"
                                 id=""
                                 className=""
                                 display="block"
                                 position="relative"/> */}

<br/>

              

           
               
                ที่มา 
                <MDBIcon icon="caret-left" /><a href='https://www.sesaokpp.go.th/cms-sesaokpp/'> บัณฑิต</a>
                    {/* <MDBIcon icon="caret-left" /><a href='https://portal.bopp-obec.info/obec64/publicstat/report'> ระบบสารสนเทศ สพม</a> */}
                    {/* <MDBIcon icon="caret-left" /><a href='/'> จำนวนนักเรียนมัธยมแต่ละโรงเรียน</a>
                     <div > <MDBIcon icon="caret-left"  /> จำนวนผู้เข้าชม</div> */}
             
              </MDBJumbotron>

       

              </FadeIn>
            </div>
          </MDBCol>
        </MDBRow>

      </MDBContainer>


    )
  }
}
